import {
  convertJSONToArray,
  convertTime,
  getItemLocalStorage,
  scoreNumberHtmlElement,
} from "@utils/function";

let checkCurrentRound =
  typeof HQ.Properties.currentRound !== "undefined" ? true : false;

const sponsorGroupPartner = HQ.Properties.appSponsorGroupPartner;

export default function ShowPlayersRow(flight) {
  let {
    matchnumber,
    status,
    currenthole,
    teetime,
    holesplayed,
    startingtee,
    matchnumber_str,
    players,
    position,
  } = flight;

  const {
    group,
    hole,
    par,
    players: player,
    pos,
    today,
    tee,
    thru,
  } = HQ.Properties.i18n["popupContent"];

  const positionGroup = position ? position : "";

  holesplayed = startingtee !== 1 ? `${holesplayed} *` : holesplayed;

  const rows = Object.entries(players)
    .map(([key, value]) => {
      let {
        id,
        totaltopar,
        totaltopar_str,
        proam,
        position_str,
        fullname,
        firstname,
        strokes,
        lastname,
        country,
        position,
      } = value;

      if (proam) {
        proam = proam === "am" ? "(A)" : "";
      } else {
        proam = "";
      }

      const roundsCurrentRoundScore = convertJSONToArray(HQ.Properties.top5)
        .filter((item) => {
          return id === item.id;
        })
        .map((item) => {
          return item.rounds[HQ.Properties.currentRound]?.score;
        });

      let totaltoparData = TotaltoparInformation(totaltopar, totaltopar_str);
      let todayColumn = checkCurrentRound
        ? +HQ.Properties.currentRound > 1
          ? roundsCurrentRoundScore
          : totaltoparData !== null
          ? totaltoparData
          : ""
        : "";

      // console.log(todayColumn);

      totaltopar = !totaltopar
        ? totaltopar_str
        : totaltopar < 0
        ? scoreNumberHtmlElement("danger", totaltopar_str)
        : scoreNumberHtmlElement("success", totaltopar_str);

      firstname = firstname != undefined ? `${firstname.slice(0, 1)}.` : "";
      lastname = lastname != null ? lastname : "";

      const countryFlag = country
        ? `<span title="${country}" class="flag-icon flag-icon-${country.toLowerCase()}"></span>`
        : "";

      return `
        <tr data-id-player=${id}>
          <th>${firstname} ${lastname} ${proam}</th>
          <td class="top-five-country">${countryFlag}</td>
          <td class="text-center">${position_str || "-"}</td>
          ${
            +HQ.Properties.currentRound > 1
              ? `<td class="text-center">${todayColumn}</td>`
              : ""
          }
          <td class="text-center">${
            totaltopar && totaltopar != "null" ? totaltopar : ""
          }</td>
          <td class="text-center">${status !== "TEE" ? holesplayed : ""}</td>
        </tr>`;
    })
    .join("");

  const logo = sponsorGroupPartner
    ? `<img class="img-fluid group-partner-logo" src="${sponsorGroupPartner}">`
    : "";

  const todayRow =
    +HQ.Properties.currentRound > 1
      ? `<th scope="col" class="text-center">${today}</th>`
      : "";

  const groupPartnerClass =
    HQ.Properties.mode === "iframe"
      ? "group_partner group_partner_iframe"
      : "group_partner";

  const showHeadShotPlayer =
    HQ.Properties.headShow === "1" ? payersHeadShot(players) : "";

  return `
    <div class="popup-content">
      ${showHeadShotPlayer}
      <div class="popup-header">
        <div class="row">
          <div class="col">
            <h3><span>${group}</span> ${matchnumber}</h3>
            <div class="tee-time">
              <span>${tee}</span>: ${startingtee} 
              <span class="ps-1">${convertTime(teetime.slice(0, 5))}</span>
            </div>
            <div class="d-flex">
                <div class="holes-played">
                    <span>${hole}</span>: ${currenthole}
                </div>
                ${ShowGroupPosition(positionGroup)}
            </div>
          </div>
          <div class="col d-flex align-self-center ${groupPartnerClass}">${logo}</div>
        </div>
      </div>
      <table class="table table-borderless mt-1">
        <thead>
          <tr>
            <th scope="col">${player}</th>
            <th scope="col"></th>
            <th scope="col" class="text-center">${pos}</th>
             ${todayRow}
            <th scope="col" class="text-center">${par}</th>
            <th scope="col" class="text-center">${thru}</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    </div>`;
}

function TotaltoparInformation(totaltopar, totaltopar_str) {
  return totaltopar
    ? totaltopar < 0
      ? `<span class="text-danger">${totaltopar_str}</span>`
      : `<span class="text-success">${totaltopar_str}</span>`
    : totaltopar_str;
}

/**
 * Show group position (Green, Fairway, Tee)
 * https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/557
 *
 * @param {string | number} position
 */
function ShowGroupPosition(position) {
  let positionGroupText = "";
  if (position === 1) {
    positionGroupText = "Green";
  } else if (position === 2 || position === 3) {
    positionGroupText = "Fairway";
  } else if (position === "TEE") {
    positionGroupText = "Tee";
  }

  const groupPosition = position
    ? `<div class="group-position">${positionGroupText}</div>`
    : "";

  return groupPosition;
}

/**
 * Add players headshot
 * https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/685
 *
 * @param {obj} players
 * @returns HTMLElement
 */
function payersHeadShot(players) {
  // const lastElement = players[3];
  // players["4"] = lastElement;
  // delete players["3"];

  const player = Object.entries(players)
    .map(([key, value], index) => {
      let { image_player, fullname } = value;

      // image_player = index === 1 || index === 3 ? "" : image_player;

      // LPGA
      // image_player =
      //   "https://www.lpga.com/-/media/images/lpga/players/h/henseleit/esther/esther-heseleit_23hs_470x486.jpg?h=150&la=en&w=150&hash=C685A0C4BF91D024B332D11E06E3E7A5CC463730";

      // image_player =
      //   "https://www.lpga.com/-/player-data/gladiator-image/-/media/images/lpga/players/k/kim/sei-young/kim_sei_young_bio2021_620x650.png";

      // DPWT
      // image_player =
      //   "https://www.europeantour.com/api/images/image/private/t_et__card_content_272x272-2x/PROD/u4zdvdjtyz0xonsk7z12";

      // LET
      // image_player =
      //   "https://tms-images.ams3.cdn.digitaloceanspaces.com/let/media/photos/911243.jpg";

      let createShowPlayersRow = !image_player ? 'class="player-shadow"' : "";

      const imagePlayer = image_player
        ? `<img src="${image_player}" alt="${fullname}" title="${fullname}" class="img-fluid">`
        : `<svg ${createShowPlayersRow}><use href="#icon-round-headshot"></use></svg>`;

      return `
        <div class="player-wrapper">
          ${imagePlayer}
        </div>`;
    })
    .join("");

  return `<div class="players-headshot d-flex">${player}</div>`;
}
